module.exports = __webpack_public_path__ + "static/media/bg_light.b96f011a.svg";